/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";
import { ScheduleFiltersEntity } from "sh-models";
import { ScheduleFiltersStore } from "../store/store";

/**
 * Sets the schedule filters store.
 */
export const setScheduleFilters = mutatorAction(
    "setScheduleFilters",
    (scheduleFilters: ScheduleFiltersEntity) => {
        ScheduleFiltersStore().scheduleFilters = scheduleFilters;
    }
);